import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/Layout";

import GuiaFinanceiro from "./pages/guifianceiro";
import Noticia from "./pages/noticia";
import Politica from "./pages/politica";
import Fofoca from "./pages/fofoca";
import SobreNos from "./pages/sobrenos";
import PoliticaDePrivacidade from "./pages/politicadeprivacidade/index";
import Investimento from "./pages/investimento"
import Financa from "./pages/financa"
import Divida from "./pages/divida"
import Error from "./pages/error";

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <GuiaFinanceiro />
      },
      {
        path: "/noticia",
        element: <Noticia />
      },
      {
        path: "/politica",
        element: <Politica />
      },
      {
        path: "/fofoca",
        element: <Fofoca />
      },
      {
        path: "/sobrenos",
        element: <SobreNos/>
      },
      {
        path: "/politicadeprivacidade",
        element: <PoliticaDePrivacidade />
      },
      {
        path: "/investimento",
        element: <Investimento />
      },
      {
        path: "/financas",
        element: <Financa />
      },
      {
        path: "/divida",
        element: <Divida />
      },
      {
        path: "*",
        element: <Error />
      },
    ],
  }
])

export default router;
